module.exports = __webpack_public_path__ + "static/media/meet-team.a637a8b7.png";